/* Victor Rybakov
 * 16 Aug 2016
 * GaugeRangeContainerField is needed for Config dialog of Gauge widget;
 * it allows to create/delete the color ranges in Circular and Linear Gauge Range-Container;
 * rybak@pdc.spb.su
 */

import * as React from 'react';

import * as _ from 'underscore';
import NumberField from '../../../../_common/platform/tsx/NumberField';
import StringField from '../../../../_common/platform/tsx/StringField';
import { ColorBoxField } from '../../../../_common/platform/tsx/ColorBoxField';

// from TS file:
import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../../_common/platform/ts/ParameterFieldBase';

class GaugeRangeContainerRow extends React.Component<
    {
        key: string;
        i: number;
        value?: any;
        onChange(value, i);
        onRemove?(i);
        glob;
    },
    any
> {
    constructor(props) {
        super(props);

        this.state = {};
    }

    private static START_COLOR_DEFAULT = '#ffff00'; // yellow

    processNameChange = (val) => {
        const obj = _.clone(this.props.value || {});
        obj.name = val;
        this.handleValueChange(obj);
    };

    processNameClick = () => {
        const obj = _.clone(this.props.value || {});
        obj.name = '';
        this.handleValueChange(obj);
    };

    processStartColorChange_ColorBox = (value) => {
        var obj = _.clone(this.props.value || {});
        obj.color = value;
        this.handleValueChange(obj);
    };

    processStartValueChange = (val) => {
        //let val = e; //this.refs.startValue.value;
        if (typeof val === 'string') {
            const K = parseInt(val);
            if (!isNaN(K)) val = K;
            else val = 0;
        }
        const obj = _.clone(this.props.value || {});
        obj.startValue = val;
        this.handleValueChange(obj);
    };

    processEndValueChange = (val) => {
        //let val = e; //this.refs.startValue.value;
        if (typeof val === 'string') {
            const K = parseInt(val);
            if (!isNaN(K)) val = K;
            else val = 0;
        }
        const obj = _.clone(this.props.value || {});
        obj.endValue = val;
        this.handleValueChange(obj);
    };

    handleValueChange = (value) => {
        if (value.name == null) {
            delete value.color;
            delete value.startValue;
            delete value.endValue;
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value, this.props.i);
        }
    };

    handleRemove = () => {
        if (typeof this.props.onRemove === 'function') {
            this.props.onRemove(this.props.i);
        }
    };

    getRemoveButton = (value) => {
        if (value.name == null) {
            return;
        }

        return <span className="glyphicon glyphicon-remove" onClick={this.handleRemove}></span>;
    };

    getName = (value) => {
        let displayVal = value.name || '';

        if (value.name == null) {
            displayVal = (
                <em className="empty" onClick={this.processNameClick}>
                    add
                </em>
            );
            return (
                <div className="entity-select">
                    <div className="content">
                        <span className="glyphicon glyphicon-cog" onClick={this.processNameClick}></span>
                        <span className="value">{displayVal}</span>
                    </div>
                </div>
            );
        }

        return <StringField onChange={this.processNameChange} value={displayVal} />;
    };

    getStartValue = (value) => {
        if (value.name == null) {
            return;
        }
        const displayVal = value.startValue || 0;
        return <NumberField value={displayVal} onChange={this.processStartValueChange} />;
    };

    getEndValue = (value) => {
        if (value.name == null) {
            return;
        }
        const displayVal = value.endValue || 0;
        return <NumberField value={displayVal} onChange={this.processEndValueChange} />;
    };

    getRangeBarColor = (value) => {
        if (value.name == null) {
            return;
        }

        const displayVal = value.color || GaugeRangeContainerRow.START_COLOR_DEFAULT;

        return (
            <ColorBoxField
                value={displayVal}
                hideTransparency={true}
                showText={false}
                onChange={this.processStartColorChange_ColorBox}
                glob={this.props.glob}
            />
        );
    };

    render() {
        const value = this.props.value || {};

        return (
            <tr>
                <td className="cell-remove">{this.getRemoveButton(value)}</td>
                <td className="cell-name">{this.getName(value)}</td>
                <td className="cell-start-value">{this.getStartValue(value)}</td>
                <td className="cell-end-value">{this.getEndValue(value)}</td>
                <td className="cell-range-bar-color">{this.getRangeBarColor(value)}</td>
            </tr>
        );
    }
}

function getState() {
    return {};
}

export class GaugeRangeContainerRowField extends React.Component<
    {
        value;
        border: boolean;
        onChange(value);
        glob;
    },
    any
> {
    constructor(props) {
        super(props);

        this.state = _.extend({}, getState.call(this), {});
    }

    private static DEFAULT_RANGE_SET = [
        { startValue: 0, endValue: 10, color: '#CE2029' },
        { startValue: 10, endValue: 20, color: '#FFD700' },
        { startValue: 20, endValue: 30, color: '#228B22' },
        { startValue: 30, endValue: 40, color: '#FF00FF' },
        { startValue: 40, endValue: 50, color: '#8080FF' },
        { startValue: 50, endValue: 100, color: '#FF8000' }
    ];

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    _onChange = () => {
        this.setState(getState.call(this));
    };

    componentDidUpdate(prevProps, prevState) {}

    handleValueChange = (value) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    addRow = (obj: any) => {
        const arr = this.props.value.slice(0);
        let len = arr.length;
        if (len > 5) len = len % 5;
        obj.color = GaugeRangeContainerRowField.DEFAULT_RANGE_SET[len].color;
        obj.startValue = GaugeRangeContainerRowField.DEFAULT_RANGE_SET[len].startValue;
        obj.endValue = GaugeRangeContainerRowField.DEFAULT_RANGE_SET[len].endValue;
        arr.push(obj);
        this.handleValueChange(arr);
    };

    changeRow = (obj: any, i) => {
        const arr = this.props.value.slice(0);
        const prev = arr.splice(i, 1, obj)[0];

        this.handleValueChange(arr);
    };

    removeRow = (i) => {
        const arr = this.props.value.slice(0);
        arr.splice(i, 1);
        this.handleValueChange(arr);
    };

    render() {
        const self = this;

        const rows = _.map(
            this.props.value,

            function (obj, i) {
                return (
                    <GaugeRangeContainerRow
                        key={i + '-'}
                        i={i}
                        value={obj}
                        glob={self.props.glob}
                        onChange={self.changeRow}
                        onRemove={self.removeRow}
                    />
                );
            }
        );
        // + obj.attribute

        const showTableHeaders = rows.length > 0;
        const style1 = {
            marginBottom: 5
        };

        // style={{'minWidth': 'unset'
        return (
            <div className={'gauge-range-container-field'}>
                <div className={'div-container'}>
                    <table className={'table' + (this.props.border === true ? ' table-bordered' : '')} style={style1}>
                        {showTableHeaders === true ? (
                            <thead>
                                <tr>
                                    <th className="cell-remove"></th>
                                    <th className="cell-name">Name</th>
                                    <th className="cell-start-value">Start Value</th>
                                    <th className="cell-start-value">End Value</th>
                                    <th className="cell-range-bar-color">Range Color</th>
                                </tr>
                            </thead>
                        ) : null}

                        <tbody>
                            {rows}

                            <GaugeRangeContainerRow key={'00-'} i={-1} onChange={this.addRow} glob={this.props.glob} />
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export class GaugeRangeContainerField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = GaugeRangeContainerRowField;

    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        if (defaultVal == null) {
            defaultVal = GaugeRangeContainerField.getDefaultValue();
        }

        super(glob, title, GaugeRangeContainerField.defaultValidators, validators, defaultVal, options);
    }
}
